<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title" v-if="did">{{did.short_name}}</h4>
                                <h5 class="card-subtitle"> Please keep your profile information always current in order
                                    to help you when you contact us. </h5>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <a :href="$BORLAUG + '/identity/did:bws:' + memberid.toString().substring(2, memberid.length)"
                                   target="_blank">
                                    <img class="bws-ico" src="@/assets/images/orange_bws_logo.png">&nbsp;&nbsp;View on
                                    Blockchain</a>
                            </div>
                        </div>
                        <ul class="nav nav-tabs mt-4" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#personal" role="tab">
                                    <span class="hidden-sm-up"></span>
                                    <i class="ti-user"></i>
                                    <span class="hidden-xs-down ml-1">Personal Info</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#business" role="tab">
                                    <span class="hidden-sm-up"></span>
                                    <i class="ti-briefcase"></i>
                                    <span class="hidden-xs-down ml-1">Business Info</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#financial" role="tab">
                                    <span class="hidden-sm-up"></span>
                                    <i class="ti-money"></i>
                                    <span class="hidden-xs-down ml-1">Financial Info</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#tx" role="tab">
                                    <span class="hidden-sm-up"></span>
                                    <i class="ti-exchange-vertical"></i>
                                    <span class="hidden-xs-down ml-1">Transactions</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <form class="form-horizontal">
                        <div class="tab-content tabcontent-border">
                            <div class="tab-pane active" id="personal" role="tabpanel">
                                <personal-info-tab :did_attachments="did_attachments" :did_records="did_records"
                                                   :memberid="memberid"></personal-info-tab>
                            </div>
                            <div class="tab-pane" id="business" role="tabpanel">
                                <business-info-tab :memberid="memberid"
                                                   :value_chain_list="value_chain_list"></business-info-tab>
                            </div>
                            <div class="tab-pane" id="financial" role="tabpanel">
                                <financial-tab :memberid="memberid" :service_list="service_list"></financial-tab>
                            </div>
                            <div class="tab-pane" id="tx" role="tabpanel">
                                <transaction-tab :did="memberid"></transaction-tab>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import ProfileByPublicKey from "../../../common/ProfileByPublicKey";
    import FinancialTab from "./sections/FinancialTab";
    import ClaimAttachments from "./sections/ClaimAttachments";
    import PersonalInfoTab from "./sections/PersonalInfoTab";
    import TransactionTab from "./sections/TransactionTab";
    import {mapGetters} from "vuex";
    import BusinessInfoTab from "./sections/BusinessInfoTab";

    export default {
        name: "ViewMember",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {
            BusinessInfoTab,
            TransactionTab, PersonalInfoTab, ClaimAttachments, FinancialTab, ProfileByPublicKey
        },
        props: ['catalogid', 'memberid'],
        data() {
            return {
                did: null,
                did_records: [],
                claims: [],
                value_chain_list: [],
                value_chain_items: [],
                service_list: [],
                service_items: [],
                did_attachments: [],
                template_attributes: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getActiveDidTemplate();
                await Promise.all([
                    this.getDid(),
                    this.getDidRecords(),
                    this.getClaims(),
                    this.getDidAttachments()
                ])
            },
            async getActiveDidTemplate() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs/${this.catalogid}/active_did_template`);
                    this.template_attributes = data.template ? data.template_fields : [];
                } catch (e) {
                }
            },
            async getDid() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs/${this.catalogid}/dids/${this.memberid}`);
                    this.did = data;
                } catch (e) {
                }
            },
            async getDidRecords() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$identity.get(`/identity/dids/${this.memberid}/properties?page=0&per_page=1000`);
                    let did_records = data.property_list.filter(p => (p.fact.value.length !== 66 && p.fact.value.indexOf('0x') !== 0));
                    let result = [];
                    let extra = [];
                    let self = this;
                    if (this.template_attributes.length > 0) {
                        this.template_attributes.forEach(function (key, index) {
                            let found = false;
                            did_records = did_records.filter(function (item) {
                                if (!found && item.name === key.name) {
                                    result.push(item);
                                    found = true;
                                    return false;
                                } else
                                    return true;
                            });
                            if (index === self.template_attributes.length - 1) {
                                extra = did_records;
                            }
                        });
                    } else {
                        result = did_records;
                    }
                    this.did_records = [...result, ...extra];
                } catch (e) {
                    console.error(e)
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getClaims() {
                try {
                    let {data} = await this.$identity.get(`/identity/dids/${this.memberid}/claims?page=0&per_page=1000`);
                    let miscellaneous_name_index = 0, miscellaneous_item_index = 0;
                    data.claims.forEach(claim => {
                        let found = claim.statements.find(value_chain => value_chain.name.toLowerCase().indexOf('value chain') !== -1);
                        let found_service = claim.statements.find(value_chain => value_chain.name.toLowerCase().indexOf('service') !== -1);
                        let found_name = claim.statements.find(value_chain => value_chain.name.toLowerCase().indexOf('item') !== -1);
                        let status = null;
                        if (!claim.expiry && claim.current_attestations_count === 0) {
                            status = 'Pending';
                        } else if (moment(claim.expiry) >= moment()) {
                            status = 'Attested';
                        } else {
                            status = 'Expired';
                        }
                        if (found) {
                            let index_to_change = null;
                            let exist_value_chain = this.value_chain_list.find((vcl, i) => {
                                index_to_change = i;
                                return vcl.name === found.fact.value
                            });
                            if (exist_value_chain) {
                                let item_index_to_change = null;
                                let exist_value_chain_item = this.value_chain_list[index_to_change].item_set.find((f_item, i) => {
                                    item_index_to_change = i;
                                    return (found_name && (f_item.name === found_name.fact.value)) || (!found_name && f_item.name === 'Others')
                                });
                                if (exist_value_chain_item) {
                                    this.value_chain_list[index_to_change].item_set[item_index_to_change].values.push({
                                        claim: claim.claim,
                                        description: claim.description,
                                        status: status,
                                        created_by: claim.created_by,
                                        attested_by: claim.attested_by,
                                        created: claim.created,
                                        expiry: claim.expiry,
                                        items: claim.statements.filter(s => (s.name !== found.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                        attachments: claim.attachments ? claim.attachments : []
                                    });
                                } else {
                                    this.value_chain_list[index_to_change].item_set.push({
                                        name: found_name ? found_name.fact.value : 'Others',
                                        values: [{
                                            claim: claim.claim,
                                            description: claim.description,
                                            status: status,
                                            created_by: claim.created_by,
                                            attested_by: claim.attested_by,
                                            created: claim.created,
                                            expiry: claim.expiry,
                                            items: claim.statements.filter(s => (s.name !== found.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                            attachments: claim.attachments ? claim.attachments : []
                                        }]
                                    })
                                }
                                console.log(JSON.stringify(this.value_chain_list))
                                console.log(JSON.stringify(this.did_records))
                                console.log(JSON.stringify(this.did_attachments))


                            } else {
                                this.value_chain_list.push({
                                    claim: claim.claim,
                                    name: found.fact.value,
                                    item_set: [{
                                        name: found_name? found_name.fact.value : 'Others',
                                        values: [{
                                            claim: claim.claim,
                                            description: claim.description,
                                            status: status,
                                            created_by: claim.created_by,
                                            attested_by: claim.attested_by,
                                            created: claim.created,
                                            expiry: claim.expiry,
                                            items: claim.statements.filter(s => (s.name !== found.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                            attachments: claim.attachments ? claim.attachments : []
                                        }]
                                    }]
                                })
                            }
                        } else if (found_service) {
                            let index_to_change = null;
                            let exist_service = this.service_list.find((sl, i) => {
                                index_to_change = i;
                                return sl.name === found_service.fact.value
                            });
                            if (exist_service) {
                                this.service_list[index_to_change].items.push({
                                    claim: claim.claim,
                                    description: claim.description,
                                    status: status,
                                    created_by: claim.created_by,
                                    attested_by: claim.attested_by,
                                    created: claim.created,
                                    expiry: claim.expiry,
                                    items: claim.statements.filter(s => (s.name !== found_service.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                    attachments: claim.attachments ? claim.attachments : []
                                })
                            } else {
                                this.service_list.push({
                                    claim: claim.claim,
                                    name: found_service.fact.value,
                                    items: [{
                                        claim: claim.claim,
                                        description: claim.description,
                                        status: status,
                                        created_by: claim.created_by,
                                        attested_by: claim.attested_by,
                                        created: claim.created,
                                        expiry: claim.expiry,
                                        items: claim.statements.filter(s => (s.name !== found_service.name) && (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                        attachments: claim.attachments ? claim.attachments : []
                                    }]
                                })
                            }
                        } else {
                            if (miscellaneous_name_index === 0) {
                                this.value_chain_list.push({
                                    claim: claim.claim,
                                    name: 'Miscellaneous',
                                    item_set: [{
                                        name: 'All',
                                        values: [{
                                            claim: claim.claim,
                                            description: claim.description,
                                            status: status,
                                            created_by: claim.created_by,
                                            attested_by: claim.attested_by,
                                            created: claim.created,
                                            expiry: claim.expiry,
                                            items: claim.statements.filter(s => (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                            attachments: claim.attachments ? claim.attachments : []
                                        }]
                                    }]
                                })
                                miscellaneous_name_index++;
                            } else {
                                let index_to_change = null;
                                this.value_chain_list.find((vcl, i) => {
                                    index_to_change = i;
                                    return vcl.name === 'Miscellaneous'
                                });
                                this.value_chain_list[index_to_change].item_set[0].values.push({
                                    claim: claim.claim,
                                    description: claim.description,
                                    status: status,
                                    created_by: claim.created_by,
                                    attested_by: claim.attested_by,
                                    created: claim.created,
                                    expiry: claim.expiry,
                                    items: claim.statements.filter(s => (s.fact.value.length !== 66 && s.fact.value.indexOf('0x') !== 0)),
                                    attachments: claim.attachments ? claim.attachments : []
                                })
                            }
                        }
                    })
                    this.value_chain_list = this.value_chain_list.map(vcl => ({
                        ...vcl,
                        item_set: vcl.item_set.map(is => ({
                            ...is,
                            values: is.values.reverse()
                        }))
                    }))
                    console.log(JSON.stringify(this.service_list))
                } catch (e) {
                    console.error(e)
                }
            },
            async getDidAttachments() {
                try {
                    let {data} = await this.$identity.get(`/identity/dids/${this.memberid}/documents`);
                    this.did_attachments = data.did_attachment_list;
                } catch (e) {
                }
            }
        }
    }
</script>

<style scoped>
</style>
